module.exports = __webpack_public_path__ + "static/ITCAvantGardeStd-Bk-ae9fe6c6025aa74cfd266d190250163a.woff";